<style scoped>
.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 20px auto;
  width: 70%;
  padding: 20px 60px;
}
.cost-title {
  /* height: 72px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 14px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  align-items: center;
}
.cost-approve-list-title {
  width: 180px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  flex-direction: row-reverse;
  padding-bottom: 30px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
/* 表头设置 */
.setHeadClass .setHead {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.setHeadClass .setHead p {
  margin: 0;
}

.setHeadClass .setHead .left {
  width: 300px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  margin-right: 10px;
  height: 556px;
  overflow-y: scroll;
}

.setHeadClass .setHead .right {
  flex: 1;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
}

.setHeadClass .setHead .right .top {
  text-align: right;
  margin-bottom: 12px;
}
.btnArea span {
  text-decoration: underline;
  color: #4fa1a4;
  margin-left: 12px;
  cursor: pointer;
}
.product {
  display: flex;
  align-items: center;
}
.product-img {
  width: 60px;
  height: 40px;
  margin-right: 15px;
}
.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cost-input {
  width: 300px;
}
.add-label-btn {
  width: 80px;
  height: 40px;
  line-height: 36px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  background: #4fa1a4;
}
.label-box {
  display: flex;
}
.upload-list{
  width: 500px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 24px;
}
.upload-list-del{
  margin-right: 10px;
  cursor: pointer;
}
 /*被拖拽对象的样式*/
.dragg-item {
  padding: 6px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  /* cursor: move; */
} 
.chosen{
  color: #4fa1a4;
  cursor: move;
  border: solid 2px #adaeaf !important;
}
</style>
<template>
  <div class="cost-content">
    <div class="costApprove" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="cost-title">
        <div class="flow-name">联系人资料</div>
        <div class="flow-back" @click="goBack()">返回</div>
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">基本信息</span>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>所属企业：</div>
        <el-select :disabled ="disabled||$route.query.guid"  v-model="form.tenantGuid" filterable placeholder="请选择" class="cost-input" @change="changeCompany">
          <el-option
            v-for="item in companyList"
            :key="item.sendTenantGuid"
            :label="item.sendTenantName"
            :value="item.sendTenantGuid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>联系人类型：</div>
        <el-select :disabled ="disabled||$route.query.guid"  v-model="form.clientType" filterable placeholder="请选择" class="cost-input" @change="changeClientType">
          <el-option
            v-for="item in clientTypeList"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 所属商业公司： -->
      <div class="cost-approve-list" v-show="getFieldConfig('franchiseeName', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('franchiseeName', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("franchiseeName", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled" 
            type="text"
            v-model="form.franchiseeName"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('franchiseeName', 'tipText')"
            @focus="dialogFran = true"
          ></el-input>
        </div>
      </div>
      <!-- 姓名： -->
      <div class="cost-approve-list" v-show="getFieldConfig('clientName', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('clientName', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("clientName", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled" 
            ref="clientNameRef"
            type="text"
            v-model.trim="form.clientName"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('clientName', 'tipText')"
            :maxlength="50"
            @input="form.clientName=form.clientName.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g,'')"
            @blur="nameBlur(form.clientName,form,'clientName')"
          ></el-input>
        </div>
      </div>
      <!-- 联系方式： -->
      <div class="cost-approve-list" v-show="getFieldConfig('mobileNo', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('mobileNo', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("mobileNo", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled" 
            type="text"
            v-model.trim="form.mobileNo"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('mobileNo', 'tipText')"
            @input="form.mobileNo=form.mobileNo.replace(/[^\d\-\d]/g,'')"
          ></el-input>
        </div>
      </div>
      <!-- 性别： -->
      <div class="cost-approve-list" v-show="getFieldConfig('sex', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('sex', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("sex", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-select :disabled ="disabled"  v-model="form.sex" class="cost-input" :placeholder="getFieldConfig('sex', 'tipText')" filterable>
            <el-option v-for="item in transform(getFieldConfig('sex', 'selectItemList'))" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
         <!-- 岗位： -->
       <div class="cost-approve-list" v-show="getFieldConfig('position', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('position', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("position", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-select v-if="form.clientType==15" :disabled="disabled" v-model="form.positionGuid" @change="handlePosition(1)" class="cost-input" :placeholder="getFieldConfig('position', 'tipText')" filterable>
            <el-option v-for="item in getCodeListByKey('药店联系人岗位')" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          <el-cascader v-else  :disabled ="disabled"  :placeholder="getFieldConfig('position', 'tipText')" class="w300" ref="cascaderAddr" v-model="form.positionGuid" @change="handlePosition(0)"
              :options="getCodeListByKey('部门名称字典')" clearable :props="cascaderProps" filterable></el-cascader>
        </div>
      </div>
      <!-- 建档时间： -->
      <div class="cost-approve-list" v-show="getFieldConfig('inputDate', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('inputDate', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("inputDate", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-date-picker :disabled ="disabled" 
            class="cost-input"
            v-model="form.inputDate"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="getFieldConfig('inputDate', 'tipText')">
          </el-date-picker>
        </div>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>指派公司：</div>
         <el-select :disabled ="disabled" v-model="form.createUserTenantGuid" filterable placeholder="请选择" class="cost-input" @change="onChanCreateUserTenant">
          <el-option
            v-for="item in serviceTenants"
            :key="item.guid" 
            :label="item.tenantName" 
            :value="item.guid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>业务指派人员：</div>
        <el-select :disabled ="disabled"  v-model="form.createUserId" filterable placeholder="请选择" class="cost-input" @change="changeStaff">
          <el-option
            v-for="item in staffList"
            :key="item.userGuid"
            :label="item.staffName + ' - ' + item.mobileNo"
            :value="item.userGuid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>启用状态：</div>
        
        <el-radio-group class="cost-input" :disabled="disabled" v-model="form.bizState">
          <el-radio label="Y">启用</el-radio>
          <el-radio label="S">停用</el-radio>
        </el-radio-group>
      </div>
      <div class="cost-submit-btn mt15" v-if="!disabled">
        <div class="cost-submit-btn-sure" @click="submit(1)">添加下一个</div>
        <div class="cost-submit-btn-sure" @click="submit()">提 交</div>
        <div class="cost-submit-btn-cancel" @click="$router.go(-1)">取 消</div>
      </div>
    </div>
    <div class="h20"></div>
    <el-dialog :title="'请选择'+getFieldConfig('franchiseeName', 'fieldAlias')" :visible.sync="dialogFran" :modal-append-to-body="false" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">关键字：</div>
          <el-input :disabled ="disabled"  v-model="joinKeyWords" class="ipt-sty" placeholder="请输入名称"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="medium" type="info" @click="getFranchiseeList(true)">搜索</el-button>
        </el-col>
      </el-row>
      <el-table v-if="form.clientType==10" :data="franchiseeList" style="width: 100%" height="50vh" row-key="guid" border ref="dataTable" @row-click="rowClick" v-loading="tableLoading">
        <el-table-column width="60" label="选择" header-align="center" align="center">
          <template slot-scope="scope">
            <el-checkbox-group v-model="currentFranSelect" class="reimbursement-check">
              <el-checkbox :label="scope.row.guid" @change="checkFranBoxChange(scope.row)">{{scope.$index+1}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>

        <el-table-column prop="franchiseeName" label="客户名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="所在区域" header-align="center" align="center" width="300">
          <template slot-scope="scope">{{ scope.row.province | province}}{{ scope.row.city | city}}{{ scope.row.district | district}}</template>
        </el-table-column>
        <el-table-column prop="price" label="详细地址" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            {{ scope.row.address||'-' }}
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="form.clientType==15" :data="customerList" style="width: 100%" height="50vh" row-key="guid" border ref="dataTable" @row-click="rowClick" v-loading="tableLoading">
        <el-table-column width="60" label="选择" header-align="center" align="center">
          <template slot-scope="scope">
            <el-checkbox-group v-model="currentFranSelect" class="reimbursement-check">
              <el-checkbox :label="scope.row.guid" @change="checkFranBoxChange(scope.row)">{{scope.$index+1}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>

        <el-table-column prop="customerName" label="客户名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="所在区域" header-align="center" align="center" width="300">
          <template slot-scope="scope">{{ scope.row.province | province}}{{ scope.row.city | city}}{{ scope.row.district | district}}</template>
        </el-table-column>
        <el-table-column prop="price" label="详细地址" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            {{ scope.row.address||'-' }}
          </template>
        </el-table-column>
      </el-table>
      <!--商业公司分页 -->
      <el-pagination  class="pt pb back-color-fff" background @size-change="handleFranSizeChange" @current-change="handleFranCurrentChange" :page-sizes="[10, 30, 50]" :current-page="franPage.pageIndex" :page-size="franPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="franPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="cancelChoose">取消</el-button>
        <el-button size="medium" type="info" @click="sureChoose">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
import { Alert } from 'element-ui';
import recentDate from "@/uilt/recentDate";
export default {
  data() {
    return {
      disabled:(this.$route.query.disabled == 'false'||!this.$route.query.disabled) ? false : true,
      fullscreenLoading:false,
      currentCompany:'',
      form: {
        guid: '',
        tenantGuid: '',
        clientName: '',//姓名
        tenantGuid: "",
        mobileNo: "",
        sex: "",
        clientType: '10',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        franchiseeName: '',//所属公司
        franchiseeGuid: '',//所属公司Guid
        position: '',//岗位
        positionGuid:'',
        department:'',//部门
        departmentGuid:'',
        inputDate: recentDate.getNowDay(),
        accountMonth: null,
        createUserTenantGuid: '',
        createUserId:'',
        createUserMobile:'',
        createUserName:'',
        bizState:'Y',//启用状态
      },
      clientTypeList: [
        {
          value: "10",
          text: "商业公司联系人",
        },
        {
          value: "15",
          text: "药店联系人",
        },
      ],
      // 商业公司
      dialogFran:false,
      franchiseeList:[],
      customerList:[],
      currentFranSelect:[],
      franPage: {
        pageIndex: 1,
        tenantGuid: localStorage.guid,
        pageSize: 10,
        // franchiseeName: '',
        totalPage: 0,
        totalRows: 0,
      },
      joinKeyWords:'',
      companyList:[],
      serviceTenants: [],
      staffList:[],
      staffData:'',
      tableLoading:false,
      positionList:[],
      cascaderProps: { //角色级联
          value: 'guid',
          label: 'text',
          children: 'childDictList',
          multiple: false,
          emitPath:false
      },
      
    };
  },
  watch: {
    'form.inputDate'(v) {
      if (v) {
        this.getAccountMonth();
      }
    },
    // 'form.clientType':{
    //   immediate:true,
    //   deep:true,
    //   handler(newValue, oldValue) {
    //     if(newValue=='15'||(oldValue&&oldValue=='15')){
    //       this.form.positionGuid = '';
    //       this.form.departmentGuid = '';
    //       this.form.position = '';
    //       this.form.department = '';
    //     }
    //   }
    // }
  },
  async created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.currentCompany = userInfo.tenantName;
    if(!this.$route.query.guid){
      sessionStorage.removeItem('businessPageIndex')
    }
    if (this.$route.query.guid) {
      this.form.guid = this.$route.query.guid;
      this.form.clientType=this.$route.query.clientType||'10';
      await this.getData();
      this.getServiceTenants(this.form.tenantGuid);
    }else{
      this.getAccountMonth();
    }
    if(!this.$route.query.guid){
      this.getCompany()
    }
    this.getPositionList();
    // this.getFranchiseeList(true);
  },
  methods: {
    goBack(){
      sessionStorage.setItem('businessBack',1) 
      this.$router.go(-1)
    },
    getPositionList() {
      this.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=部门名称字典`
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let positionList =  res.data.data;
            positionList.forEach(item=>{
              item.childDictList.forEach(el=>{
                delete el.childDictList
              })
            })
            this.positionList = positionList;
       
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },
    handlePosition(flg){
      if(flg==0){
        let obj = this.$refs['cascaderAddr'].getCheckedNodes()[0];
        this.form.positionGuid = obj.path[1];
        this.form.departmentGuid = obj.path[0];
        this.form.position = obj.pathLabels[1];
        this.form.department = obj.pathLabels[0];
      }else{
        let list=this.getCodeListByKey('药店联系人岗位')
        list.forEach(item=>{
          if(item.value==this.form.positionGuid){
            this.form.position = item.text;
          }
        })
      }
    },
    transform(list,type) {
      var newList = [];
      if(type ==1){
        list.forEach((item) => {
          newList.push({
            key: item.text,
            value: item.text,
          });
        });
      }else{
        if(list){
          list.forEach((item) => {
            newList.push({
              name: item.text,
              value: item.value,
            });
          });
        }
      }
      return newList;
    },
    getFieldConfig(params, key) {
      var fieldList = JSON.parse(localStorage.getItem("TXL_CONFIG")).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    rowClick(row,event,column){
      this.currentFranSelect = [row.guid];
      this.form.franchiseeName =this.form.clientType==10? row.franchiseeName:row.customerName;
      this.form.franchiseeGuid = row.guid;
      // row.guid = !row.flag;
      // this.$refs.dataTable.toggleRowSelection(row, row.flag);
    },
    changeClientType(val) {
      this.form.clientType = val;
      this.form.positionGuid = '';
      this.form.departmentGuid = '';
      this.form.position = '';
      this.form.department = '';
    },
    changeCompany(val){
      if(val){
        this.form.franchiseeName=''
        this.form.tenantGuid = val;
        this.form.createUserTenantGuid = '';
        this.form.createUserId = '';
        this.getFranchiseeList(true);
        this.getServiceTenants(val);
      }
    },
    // changeType(val){
    //   this.getFranchiseeList(true);
    //   this.getStaff()
    // },
    onChanCreateUserTenant(val) {
      this.form.createUserTenantGuid = val;
      this.form.createUserId = '';
      this.getStaff(val);
    },
    getServiceTenants(tenantGuid) {
      if (!tenantGuid) {
        tenantGuid = this.form.createUserTenantGuid;
      }
      const params = {
        tenantGuid: tenantGuid,
        isService: false,
      }
      console.log(1111,params)
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-service-tenants`,
          params,
        )
        .then((res) => {
          if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.error(res.data.msg);
            return;
          }
          this.serviceTenants = res.data.data;
          this.getStaff(this.form.createUserTenantGuid);
        });
    },
    changeStaff(val){
      if(this.staffList&&this.staffList.length>0){
        this.staffList.forEach(i=>{
          if(val == i.userGuid){
            this.form.createUserMobile = i.mobileNo;
            this.form.createUserName = i.staffName;
          }
        })
      }
    },
    //获取核算月
    getAccountMonth() {
      if (!this.form.inputDate) return;
      console.log('8');
      
      let self = this;
      let tenantGuid = localStorage.guid;
      this.api.get(`/${serverConfig.msConfigureService}/sysparameter/data/get-account-month?date=` +
        this.form.inputDate +
        "&tenantGuid=" +
        tenantGuid
      ).then(function (resp) {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.form.accountMonth = resp.data.data.substr(0, 4) + "-" + resp.data.data.substr(4, 2);
        }
      });
    },
    //获取人员下拉
    getStaff(val){
      let tenantGuid = this.form.tenantGuid;
      if (val) {
        tenantGuid = val;
      }
      this.api.get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` +  tenantGuid).then( (res)=> {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
          
        }
      });
    },
    //获取公司
    getCompany() {
      return new Promise ((resolve,reject)=>{
        let self = this;
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.companyList = res.data.data || [];
              if(self.companyList&&self.companyList.length>0 &&!this.$route.query.guid){
                this.form.tenantGuid = self.companyList[0].sendTenantGuid;
                this.changeCompany(this.form.tenantGuid);
              }
              resolve()
            } else {
              self.$message.error(res.data.msg);
            }
          });
      })
    },
    async getData() {
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      await self.api
        .postJson(`/${serverConfig.msPersonnelService}/address-list/data/queryDetail`,{guid:this.$route.query.guid})
        .then((res) => {
          if (res.data.msg == 'success') {
            let data = res.data.data;
            this.form = {
              guid: data.guid,
              tenantGuid: data.tenantGuid,
              clientName: data.clientName,//姓名
              tenantGuid: data.tenantGuid,
              mobileNo: data.mobileNo,
              sex: data.sex,
              clientType: data.clientType,//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
              franchiseeName: data.franchiseeName,//所属公司
              franchiseeGuid: data.franchiseeGuid,//所属公司Guid
              position: data.position,//岗位
              positionGuid: data.positionGuid,
              department:data.department,//部门
              departmentGuid:data.departmentGuid,
              inputDate: this.$moment(data.inputDate).format('YYYY-MM-DD'),
              accountMonth: data.accountMonth,
              createUserId:data.createUserId,
              createUserMobile:data.createUserMobile,
              createUserName:data.createUserName,
              bizState:data.bizState,
              createUserTenantGuid: data.createUserTenantGuid || data.tenantGuid,
            }
            this.currentFranSelect = [data.franchiseeGuid];
            this.getCompany();
            this.getFranchiseeList(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    mobileNoChange(val){
      let reg01 =/^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
      if(!reg01.test(val)){
        this.form.mobileNo = '';
        this.$message.error('请填写正确联系方式');
      }
    },
    submit(type) {
      let self = this;

      // 所属商业公司
      if (!this.form.franchiseeName&&this.getFieldConfig("franchiseeName", "formVisible") == "Y" &&this.getFieldConfig("franchiseeName", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("franchiseeName", "fieldAlias")}不能为空`);
        return;
      }
      // 姓名
      if (!this.form.clientName&&this.getFieldConfig("clientName", "formVisible") == "Y" &&this.getFieldConfig("clientName", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("clientName", "fieldAlias")}不能为空`);
        return;
      }
      // 联系方式：
      if (!this.form.mobileNo&&this.getFieldConfig("mobileNo", "formVisible") == "Y" &&this.getFieldConfig("mobileNo", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("mobileNo", "fieldAlias")}不能为空`);
        return;
      }
      // 请选择性别
      if (!this.form.sex&&this.getFieldConfig("sex", "formVisible") == "Y" &&this.getFieldConfig("sex", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("sex", "fieldAlias")}不能为空`);
        return;
      }
      // 岗位：
      if (!this.form.positionGuid&&this.getFieldConfig("position", "formVisible") == "Y" &&this.getFieldConfig("position", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("position", "fieldAlias")}不能为空`);
        return;
      }
      // 建档时间
      if (!this.form.inputDate&&this.getFieldConfig("inputDate", "formVisible") == "Y" &&this.getFieldConfig("inputDate", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("inputDate", "fieldAlias")}不能为空`);
        return;
      }
      if (!this.form.createUserTenantGuid) {
        this.$message.error('请选择指派公司')
        return
      }
      if(!this.form.createUserId){
        this.$message.error('请选择业务指派人')
        return 
      }
      if (this.$NameCheck(this,this.form.clientName,'contacts')) { // todo 姓名长度校验
        return
      }

      self.fullscreenLoading = true;
      // this.form.tenantGuid = localStorage.guid;
      let query = JSON.parse(JSON.stringify(this.form));
      query.accountMonth = query.accountMonth.replace('-', '')
      query.serviceTenantGuid = localStorage.guid;
      query.createUserTenantName = this.createUserTenantName;
      if (query.guid) {
        self.api.put(`/${serverConfig.msPersonnelService}/address-list/data/pc-update`, query).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功！');
            if(type == 1){
              this.form = {
                guid: '',
                tenantGuid: '',
                clientName: '',//姓名
                tenantGuid: "",
                mobileNo: "",
                sex: "",
                clientType: '10',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
                franchiseeName: '',//所属公司
                franchiseeGuid: '',//所属公司Guid
                position: '',//岗位
                inputDate: recentDate.getNowDay(),
                accountMonth: null,
                createUserId:'',
                createUserMobile:'',
                createUserName:'',
                bizState:'Y',//启用状态
              }
              this.currentFranSelect = [];
              this.joinKeyWords = '';
              this.getAccountMonth();
              this.getCompany().then(()=>{
                this.getFranchiseeList(true);
              })
            }else{
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            }
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/data/pc-add`, query).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('新增成功！');
            if(type == 1){
              this.form = {
                guid: '',
                tenantGuid: '',
                clientName: '',//姓名
                tenantGuid: "",
                mobileNo: "",
                sex: "",
                clientType: this.form.clientType,//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
                franchiseeName: '',//所属公司
                franchiseeGuid: '',//所属公司Guid
                positionGuid:'',
                position: '',//岗位
                inputDate: recentDate.getNowDay(),
                accountMonth: null,
                createUserId:'',
                createUserMobile:'',
                createUserName:'',
                bizState:'Y',//启用状态
              }
              this.currentFranSelect = [];
              this.joinKeyWords = '';
              this.getAccountMonth();
              this.getCompany().then(()=>{
                this.getFranchiseeList(true)
              })
            }else{
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }

      console.log(this.imgListBd);
    },
    //获取商业公司
    getFranchiseeList(val) {
      if(!this.form.tenantGuid){
        return
      }
      if (val) {
        this.franPage = {
          pageIndex: 1,
          tenantGuid: this.form.tenantGuid,
          pageSize: 10,
          // franchiseeName: this.joinKeyWords,
          totalPage: 0,
          totalRows: 0,
        }
      }
      let url=`/${serverConfig.msCustomerService}/franchisee/data/get`
      if(this.form.clientType==10){//商业公司联系人
        this.franPage.franchiseeName=this.joinKeyWords
        this.$delete(this.franPage, 'customerName');
      }else if(this.form.clientType==15){//药店联系人
        url=`/${serverConfig.msCustomerService}/customer/data/get`
        this.franPage.customerName=this.joinKeyWords
        this.$delete(this.franPage, 'franchiseeName');
      }
      
      this.tableLoading = true;
      this.api.postCan(
        url,
        this.franPage
      ).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(this.form.clientType==10){
            this.franchiseeList = res.data.data.records;
          }else if(this.form.clientType==15){
            this.customerList = res.data.data.records;
          }
          this.franPage.totalPage = res.data.data.totalPages;
          this.franPage.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
          this.franPage.totalPage = 0;
          this.franPage.totalRows = 0;
        }
      });
    },
    checkFranBoxChange(val) {
      if (!this.currentFranSelect.length) {
        // this.currentFranSelect = [];
        this.currentFranSelect.push(val.guid);
        this.form.franchiseeName =this.form.clientType==10? val.franchiseeName:val.customerName;
        this.form.franchiseeGuid = val.guid;
      }
      // if (this.currentFranSelect.indexOf(val.guid) > -1) {
      //   this.currentFranSelect = [];
      //   this.currentFranSelect.push(val.guid);
      //   this.form.franchiseeName = val.franchiseeName;
      //   this.form.franchiseeGuid = val.guid;
      // }
    },
    sureChoose() {
      this.dialogFran = false;
    },
    cancelChoose() {
      this.dialogFran = false;
    },
    handleFranSizeChange(val) {
      this.franPage.pageIndex = val;
      this.getFranchiseeList();
    },
    handleFranCurrentChange(val) {
      this.franPage.pageIndex = val;
      this.getFranchiseeList();
    },
    /**
     * @param val 对应值
     * @param formObj 表单对象
     * @param fildeName 字段key
    */
    nameBlur(val,formObj,fildeName) {
      formObj[fildeName] = this.$NameCheckBlur(this,val,fildeName)
    }
  },
  computed: {
    createUserTenantName() {
      const tenantName = this.serviceTenants?.find(item => item.guid == this.form.createUserTenantGuid)?.tenantName;
      return tenantName;
    },
  },
};
</script> 